/**
 * Transfer API (본사 -> 협력사 송금)
 */
import { apiClient } from "@/shared/api/client";
import {
    GetTransferListResponseDto,
    PostTransferRequestDto,
    PostTransferResponseDto,
    SupplierOptionDto
} from "../types/transfer.types";
import { formatDateToISO, removeDateHyphens } from "@/shared/utils/dateUtils";
import { buildExcelDownloadUrl, downloadExcelFile } from "@/shared/utils/settlementApiHelpers";
import { getItem } from "@/shared/utils/storage";
import { TRANSFER_BASE_PATH } from "@/features/system/transfer/constants/transfer.constants";

export const transferApi = {
    /**
     * 송금 내역 목록 조회
     */
    getTransferList: async (
        fromDate: string,
        toDate: string,
        suppId?: string
    ): Promise<GetTransferListResponseDto> => {
        const formattedFromDate = removeDateHyphens(formatDateToISO(fromDate));
        const formattedToDate = removeDateHyphens(formatDateToISO(toDate));

        let url = `${TRANSFER_BASE_PATH}/list?fromDate=${formattedFromDate}&toDate=${formattedToDate}`;

        if (suppId) {
            url += `&suppId=${suppId}`;
        }

        const response = await apiClient.get<GetTransferListResponseDto>(url);
        return response.data;
    },

    /**
     * 송금 신청
     */
    requestTransfer: async (
        request: PostTransferRequestDto
    ): Promise<PostTransferResponseDto> => {
        // localStorage에서 userId 가져오기
        const userId = getItem<string>('USER_ID');
        const requestWithInsertUserId = {
            ...request,
            insertUserId: userId || ''
        };
        const response = await apiClient.post<PostTransferResponseDto>(
            `${TRANSFER_BASE_PATH}/request`,
            requestWithInsertUserId
        );
        return response.data;
    },

    /**
     * 협력사 목록 조회 (송금 대상)
     */
    getSupplierOptions: async (): Promise<SupplierOptionDto[]> => {
        const url = `${TRANSFER_BASE_PATH}/supplier-options`;
        const response = await apiClient.get<SupplierOptionDto[]>(url);
        return response.data || [];
    },

    /**
     * 송금 내역 엑셀 다운로드
     * GET /api/v1/transfer/excel?fromDate={startDate}&toDate={endDate}&suppId={suppId}
     */
    downloadExcel: async (
        fromDate: string,
        toDate: string,
        suppId?: string
    ): Promise<Blob> => {
        const url = buildExcelDownloadUrl(TRANSFER_BASE_PATH, {
            fromDate: formatDateToISO(fromDate),
            toDate: formatDateToISO(toDate),
            suppId: suppId && suppId.trim() !== '' ? suppId : undefined
        });
        return downloadExcelFile(url);
    }
};
